import { useState, type ReactNode } from "react";

import { Button, PageSection } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";

import { DangerSummary, DangerZoneSection } from "./DangerZoneSection.tsx";
import { AttributesForm } from "./personal/AttributesForm";
import { EmailForm } from "./personal/EmailForm";
import { RemoveUserDialog } from "./personal/RemoveUserDialog.tsx";

export function PersonalPage() {
  const formatMessage = useFormatMessage(formatStrings);

  const [dialog, setDialog] = useState<ReactNode>(null);

  const showRemoveAccount = () => {
    setDialog(<RemoveUserDialog close={() => setDialog(null)} />);
  };

  return (
    <>
      <PageSection header={<h3>{formatMessage("header")}</h3>}>
        <AttributesForm />
        <EmailForm />
      </PageSection>

      <DangerZoneSection>
        <DangerSummary>
          <h3>{formatMessage("removeHeader")}</h3>
          <p>{formatMessage("removeSummary")}</p>
        </DangerSummary>
        <div>
          <Button variant="contained" color="error" onClick={showRemoveAccount}>
            {formatMessage("removeLabel")}
          </Button>
        </div>
      </DangerZoneSection>

      {dialog}
    </>
  );
}

const formatStrings = {
  header: { en: "User Details" },

  removeHeader: { en: "Remove Account" },
  removeSummary: {
    en: "Removing your account will result in all your data being deleted.",
  },
  removeLabel: { en: "Remove Account" },
};
